// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-metricScorecardBar-module__bar--kcxjh {
  display: flex;
  gap: 15px;
  margin: 15px 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/metricScorecardBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB","sourcesContent":[".bar {\n  display: flex;\n  gap: 15px;\n  margin: 15px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `src-js-pages-usageReportingContainer-components-metricScorecardBar-module__bar--kcxjh`
};
export default ___CSS_LOADER_EXPORT___;
